// components/CustomToolbar.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { black, dimGrey, lightPurple } from '../../../../../../mainTheme';

export const CustomTopbar: React.FC<any> = ({ date, onNavigate }) => {
  // Calculate week range string
  const startOfWeek = moment(date).startOf('week');
  const endOfWeek = moment(date).endOf('week');
  const weekRange = `${startOfWeek.format('MMMM D')}-${endOfWeek.format('D, YYYY')}`;

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '8px 16px',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderBottom: '1px solid var(--Outline/O5, #E0E0E0)',
      }}
    >
      {/* Left: Previous week */}
      <Button
        onClick={() => onNavigate('PREV')}
        sx={{
          color: lightPurple,
          fontWeight: 500,
          textTransform: 'none',
          fontSize: 14,
          minWidth: 0,
        }}
        disableElevation
        variant="text"
      >
        {'< Previous week'}
      </Button>

      {/* Center: Calendar icon + date range */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <FontAwesomeIcon
          icon={faCalendar}
          style={{ color: dimGrey, width: 18, height: 18 }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            color: black,
            fontSize: 18,
            letterSpacing: '0.2px',
          }}
        >
          {weekRange}
        </Typography>
      </Box>

      {/* Right: Next week */}
      <Button
        onClick={() => onNavigate('NEXT')}
        sx={{
          color: lightPurple,
          fontWeight: 500,
          textTransform: 'none',
          fontSize: 14,
          minWidth: 0,
        }}
        disableElevation
        variant="text"
      >
        {'Next week >'}
      </Button>
    </Box>
  );
};
